/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Progress_AriaInputs */

const en_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export progress`)
};

const fr_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression de l'exportation`)
};

const de_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportfortschritt`)
};

const it_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzamento dell'esportazione`)
};

const ru_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прогресс экспорта`)
};

const es_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de la exportación`)
};

const zh_cn2_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口进度`)
};

const ja_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートの進捗状況`)
};

const hi_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात प्रगति`)
};

const pt_pt2_video_export_progress_aria = /** @type {(inputs: Video_Export_Progress_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso das exportações`)
};

/**
* | output |
* | --- |
* | "Export progress" |
*
* @param {Video_Export_Progress_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_progress_aria = /** @type {((inputs?: Video_Export_Progress_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Progress_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_progress_aria(inputs)
	if (locale === "de") return de_video_export_progress_aria(inputs)
	if (locale === "it") return it_video_export_progress_aria(inputs)
	if (locale === "ru") return ru_video_export_progress_aria(inputs)
	if (locale === "es") return es_video_export_progress_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_progress_aria(inputs)
	if (locale === "ja") return ja_video_export_progress_aria(inputs)
	if (locale === "hi") return hi_video_export_progress_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_progress_aria(inputs)
	return en_video_export_progress_aria(inputs)
});